import PriceTicker from "./PriceTicker";

export default function PriceTag(props) {
  return <PriceTicker {...props} />;
}
